

var mixin = {
  data() {
    return {
    }
  },
  methods: {
    isIOS() {
      if (/ipad|iphone|mac/i.test(navigator.userAgent)) {
        return true;
      }
      return false;
    },
    rand(min, max, seed) {
      if (!seed) {
        seed = Math.random();
      }
      var ret = Math.ceil(seed * ((max + 1) - min) - 1) + min;
      return ret;
    },
    openView(options, replace) {
    
      if (typeof options === "string") {
        options = { name: options };
      }
      if (typeof options === "number") return this.$router.go(options)
     
      let search = options.search || {};
      let params = options.params || {};

      if (replace) {
        params._replace = true;
        this.$root.$router.replace({ name: options.name, params: params, query: search });
        return;
      }
      this.$root.$router.push({ name: options.name, params: params, query: search });
    },
   
    getSearch(url) {
      // let route= this.$root.getRoute();
      // return route.query;
      return location.getSearch(url);
    },

    getUrlParams() {
      let route = this.$root.getRoute();
      return route.params;
    },
  },
  components: {
  },
 
};

export default mixin;
